import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCup: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconCup"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3.75C3 3.33579 3.33579 3 3.75 3H16.25C16.6642 3 17 3.33579 17 3.75V6H19.25C20.2165 6 21 6.7835 21 7.75V11.25C21 12.2165 20.2165 13 19.25 13H17V19.25C17 20.2165 16.2165 21 15.25 21H4.75C3.7835 21 3 20.2165 3 19.25V3.75ZM17 11.5H19.25C19.3881 11.5 19.5 11.3881 19.5 11.25V7.75C19.5 7.61193 19.3881 7.5 19.25 7.5H17V11.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCup;
